var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"r-tab",class:[
    _vm.balloonDirection ? `r-tab--balloon--${_vm.balloonDirection}` : '',
    {
      'r-tab--balloon': _vm.balloon,
    },
  ]},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }